import moment from 'moment';

import {
  StageStatusEnum,
  OutreachEnum,
  DateTimeModel,
} from 'api/backofficeApiClient';
import {
  BOUserStatusEnum,
  BOUserTypeFilterEnum,
  ProfileTypeEnum,
} from 'api/adminApiClient';
import { isStageConsideredAsCompleted } from 'utils/profileProgressUtils/generalProgressUtils';
import { combineDateTime } from './dateUtils';

const getRecruiterStatusName = (status?: BOUserStatusEnum) => {
  switch (status) {
    case BOUserStatusEnum.Pending:
      return 'Pending';

    case BOUserStatusEnum.Reviewed:
      return 'Reviewed';

    case BOUserStatusEnum.PriceAgreementChanged:
    case BOUserStatusEnum.OutreachConducted:
      return 'Initial outreach conducted';

    case BOUserStatusEnum.PriceAgreementSent:
      return 'Agreement sent';

    case BOUserStatusEnum.PriceAgreementSigned:
      return 'Agreement signed';

    case BOUserStatusEnum.Completed:
      return 'Profile completed';

    case BOUserStatusEnum.All:
    default:
      return 'All';
  }
};

const getRecruiterEntityName = (entity?: BOUserTypeFilterEnum) => {
  switch (entity) {
    case BOUserTypeFilterEnum.Company:
      return 'Company';
    case BOUserTypeFilterEnum.SelfEmployed:
      return 'Self-employed';
    case BOUserTypeFilterEnum.International:
      return 'International';
    case BOUserTypeFilterEnum.All:
    default:
      return 'All';
  }
};

const getRecruiterOutreachChannel = (outreachChannel?: OutreachEnum) => {
  switch (outreachChannel) {
    case OutreachEnum.Phone:
      return 'phone number';

    case OutreachEnum.Email:
    default:
      return 'email';
  }
};

const getRecruiterOutreachDates = (outreachDates?: DateTimeModel[]) => {
  if (!outreachDates?.length) return;

  return outreachDates
    .filter(
      (outreach) => !!outreach.date && !!outreach.time && !!outreach.timeZone,
    )
    .map(
      (outreachDate) =>
        `${moment
          .utc(combineDateTime(outreachDate.date, outreachDate.time))
          .format('MM/DD/YYYY hh:mm A')} ${outreachDate.timeZone}`,
    )
    .join(', or on ');
};

const isRecruiterRequest = (
  status: BOUserStatusEnum,
  stage: StageStatusEnum,
) => {
  return (
    status < BOUserStatusEnum.PriceAgreementSigned ||
    (status === BOUserStatusEnum.PriceAgreementSigned &&
      !isStageConsideredAsCompleted(stage))
  );
};

const getMemberTypeOptions = () => [
  {
    value: ProfileTypeEnum.Recruiter,
    label: 'Staffing company',
  },
  {
    value: ProfileTypeEnum.Corporate,
    label: 'Corporate talent acquisition',
  },
];

export {
  getRecruiterStatusName,
  getRecruiterOutreachDates,
  getRecruiterOutreachChannel,
  getRecruiterEntityName,
  isRecruiterRequest,
  isStageConsideredAsCompleted,
  getMemberTypeOptions,
};
